export const styles = {
  noReminders: {
    backgroundColor: '#EEEEEE',
    borderRadius: '4px',
    padding: '12px',
    textAlign: 'center',
    color: '#787878',
    fontSize: '14px',
  },
}
